import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ViewLayout } from '../layout/ViewLayout'
import { ViewPage } from '../ui/viewPage'

export const ViewRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<ViewLayout />}>
        <Route path={'/'} element={<ViewPage />} />
      </Route>
    </RoutesWithNotFound>
  )
})
